import { forwardRef, useEffect, useState } from "react";

import sparkleAvatar from "@/../../hypetrain/static/img/sparkle-avatar.svg";
import { Classes, Colors, Icon } from "@blueprintjs/core";
import styled from "@emotion/styled";

import EmbedSvg from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import PrimaryButton from "@/components/pieces/button/PrimaryButton";
import Avatar from "@/components/pieces/users/Avatar";
import { CARD_CLASSES, SUBTEXT_COLOR } from "@/css/constants";

export function AlertMessage({ name, message }) {
  return (
    <Flex py={24} opacity={0.8}>
      <span>
        <Icon icon="info-sign" size={20} color={Colors.DARK_GRAY5} />
      </span>
      <span style={{ marginLeft: "10px" }}>{` ${name} ${message}`}</span>
    </Flex>
  );
}

function ScheduleCall({ profile, onPressIntroCall, specialties = [] }, ref) {
  const [scheduling, setScheduling] = useState(false);
  const { user, acceptingNewClients, canHaveIntroSession } = profile;
  const { name } = user;

  useEffect(() => {
    if (!scheduling) return;

    const intervalId = setInterval(() => {
      setScheduling(false);
    }, 2000);
    return () => clearInterval(intervalId);
  }, [scheduling]);

  if (!user) return <Box mt={24} height={300} className={Classes.SKELETON} />;

  return (
    <Box ref={ref}>
      {!canHaveIntroSession ? null : (
        <StyledComponent
          className={CARD_CLASSES}
          backgroundColor="#FFF"
          px={[3, 3, 3, 4]}
        >
          {acceptingNewClients && specialties && specialties.length ? (
            <Flex py={3}>
              <Flex flex={3} flexDirection="column">
                <h4>{`Schedule An Intro Call with ${name}`}</h4>
                <Box
                  color={SUBTEXT_COLOR}
                >{`Get to know ${name}, share your story, and determine if it’s a match.`}</Box>
                <Box width={[1, 157]} mt={3}>
                  <PrimaryButton
                    onClick={() => {
                      setScheduling(true);
                      onPressIntroCall();
                    }}
                    loading={scheduling}
                    disabled={scheduling}
                  >
                    Schedule Now
                  </PrimaryButton>
                </Box>
              </Flex>
              <Flex justifyContent="center" className="avatar-container">
                <Avatar user={user} size={140} />
                <EmbedSvg
                  width={150}
                  height={150}
                  src={sparkleAvatar}
                  style={{ position: "absolute" }}
                />
              </Flex>
            </Flex>
          ) : (
            <AlertMessage
              name={name}
              message={`is not accepting new clients right now`}
            />
          )}
        </StyledComponent>
      )}
    </Box>
  );
}

const StyledComponent = styled(Box)`
  margin: 36px 0;

  .info-text {
    color: rgb(119, 131, 151);
  }

  .avatar-container {
    position: relative;
  }

  .sparkle {
    position: absolute;
  }

  .sparkle_1 {
    top: 0;
    right: 0;
  }

  .sparkle_2 {
    top: 20%;
    left: 0;
  }

  .sparkle_3 {
    bottom: 0;
    left: 10%;
  }
`;

export default forwardRef(ScheduleCall);
